<template>
  <span class="ai-visibility-citation-opportunity-cell" :class="`impact-${opportunity.impact}`">
    <span
      class="ai-visibility-citation-opportunity-cell__bars"
      :class="`ai-visibility-citation-opportunity-cell__bars--${opportunity.impact}`"
      aria-hidden="true"
    >
      <span></span>
      <span></span>
      <span></span>
    </span>
    <span class="label">
      {{opportunity.label}}
    </span>
  </span>
</template>

<script>
import ImpactBadge from '../../../ui/display/ImpactBadge.vue'

export default {
  name: 'CitationOpportunityCell',
  components: {
    ImpactBadge,
  },
  props: {
    opportunity: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>

.label {
  font-size: 16px;
  font-weight: 400;
}

.impact-low .label {
  color: var(--v-darkGrayColor-base);
}

.impact-medium .label {
  color: #F97316;
}

.impact-high .label {
  color: var(--v-red11Color-base);
}

.ai-visibility-citation-opportunity-cell {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.ai-visibility-citation-opportunity-cell__bars {
  display: inline-flex;
  height: 18px;
  align-items: flex-end;
  gap: 2px;
}

.ai-visibility-citation-opportunity-cell__bars span {
  display: block;
  width: 4px;
  border-radius: 999px;
  background: var(--v-gray12Color-base);
}

.ai-visibility-citation-opportunity-cell__bars span:nth-child(1) {
  height: 7px;
}

.ai-visibility-citation-opportunity-cell__bars span:nth-child(2) {
  height: 12px;
}

.ai-visibility-citation-opportunity-cell__bars span:nth-child(3) {
  height: 17px;
}

.ai-visibility-citation-opportunity-cell__bars--high span {
  background: var(--v-red11Color-base);
}

.ai-visibility-citation-opportunity-cell__bars--medium span {
  background: #F97316;

  &:last-child {
    background-color: var(--v-darkGrayColor-base);
  }
}

.ai-visibility-citation-opportunity-cell__bars--low span {
  background: var(--v-darkGrayColor-base);
}
</style>
